import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import { ref } from '@vue/composition-api';
import PageTagService from '@/services/pageTag';
export default function usePageTags(projectId, withAmount = false) {
    const tagList = ref([]);
    const getTagList = async () => {
        try {
            if (withAmount) {
                tagList.value = await PageTagService.getTagListWithAmount(projectId.value);
            }
            else {
                tagList.value = await PageTagService.getTagList(projectId.value);
            }
        }
        catch (err) {
            message.error($t('k_13bc5f1d', { arg_0: err.message }));
        }
    };
    const basicTagList = ref([]);
    const getBasicTagList = async () => {
        try {
            basicTagList.value = await PageTagService.getBasicTagList(projectId.value);
        }
        catch (err) {
            message.error($t('k_13bc5f1d', { arg_0: err.message }));
        }
    };
    const createTag = async ({ name }) => {
        try {
            await PageTagService.createTag(projectId.value, { name });
            getTagList();
        }
        catch (err) {
            message.error($t('k_b10c4baf', { arg_0: err.message }));
        }
    };
    const deleteTag = async (id) => {
        try {
            await PageTagService.deleteTag(projectId.value, id);
            getTagList();
        }
        catch (err) {
            message.error($t('k_d1ab8b07', { arg_0: err.message }));
        }
    };
    const updateTag = async ({ id, name }) => {
        try {
            await PageTagService.updateTag(projectId.value, id, { name });
            getTagList();
        }
        catch (err) {
            message.error($t('k_7976dccb', { arg_0: err.message }));
        }
    };
    return {
        tagList,
        getTagList,
        basicTagList,
        getBasicTagList,
        createTag,
        deleteTag,
        updateTag,
    };
}
